import ajax from "../utils/request.js";

//获取个人信息
export const getUserInfo = (data) => {
    return ajax.post("users/getinfo", data)
}
//修改用户头像和用户名
export const changeUserInfo = (data) => {
    return ajax.post("users/setinfo", data)
}
//上传图片 name为file
export const postImg = (data) => {
    return ajax.post("api/dyuploadimg", data)
}

